export default "__VITE_ASSET__66961c77__"